export default __webpack_public_path__ + "static/13885-51419258243276837c3351388665ab05.jpg";